import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class PointParkingService {
    //get = (callback, queryParams) => AxiosService.get(apiUrl('/api/point-parc/cva'), callback, queryParams);
    getCvaDisponible = (callback, queryParams) => AxiosService.get(apiUrl('/api/point-parc/cva-disponible'), callback, queryParams);
    getEtatMateriel = (callback, queryParams) => AxiosService.get(apiUrl('/api/point-parc/vehicule'), callback, queryParams);
    //get = (callback, queryParams) => AxiosService.get(apiUrl('/api/point-parc/vehicule-disponible'), callback, queryParams);
    //get = (callback, queryParams) => AxiosService.get(apiUrl('/api/point-parc/vehicule-en-mission'), callback, queryParams); 
    
}